"use client";
import { hashCard } from "@/utils/encrypt";
declare global {
  interface Window {
    newrelic?: any;
  }
}

// What - Set Custom Attribute (gigya UID)
// When - When a user logs in, it would trigger this event
export function setCustomgigyaUid(type: string, gigyaUid: string) {
  const newrelic = window?.newrelic;
  if (newrelic != undefined) {
    /**
     * Not set custom attribute if gigyaUid is set
     */
    if (type === "webGUID") {
      newrelic.setCustomAttribute(type, gigyaUid, true);
      newrelic.setUserId(null);
    } else if (type === "_ga") {
      newrelic.setCustomAttribute("webGUID", null, true);
      newrelic.setUserId(null);
    } else {
      newrelic.setCustomAttribute("webGUID", null, true);
      newrelic.setUserId(gigyaUid);
    }
  }
}

// What - Set Banner and Region
// When - When application sets banner and region, it would trigger this event
export function setBannerRegion(status: string) {
    const newrelic = window?.newrelic;
  if (newrelic != undefined) {
    newrelic.addPageAction("setBannerRegion", {
      status: status,
      promiseTime: new Date().toDateString(),
    });
  }
}

// What - Banner and Region update
// When - When application updates banner and region, it would trigger this event
export function updateBannerRegion(status: string, banner = "") {
    const newrelic = window?.newrelic;
  if (newrelic != undefined) {
    newrelic.addPageAction("updateBannerRegion", {
      status: status,
      promiseTime: new Date().toDateString(),
      region: banner,
    });
  }
}

// What - Verification code submission
// When - When verification code is submitted to the application, it would trigger this event
export function accountCodeVerification(webGuid: string, status: string) {
    const newrelic = window?.newrelic;
  if (newrelic != undefined) {
    newrelic.addPageAction("accountCodeVerification", {
      status: status,
      promiseTime: new Date().toDateString(),
    });
  }
}

// What - Enrolment status (enquire API status code)
// When - When application enquires for an enrolment, it would trigger this event
export function enquireEnrolment(
  webGuid: string,
  status: string,
  enrolmentStatusCode = ""
) {
    const newrelic = window?.newrelic;
  if (newrelic != undefined) {
    newrelic.addPageAction("enquireEnrolment", {
      status: status,
      promiseTime: new Date().toDateString(),
      enrolmentStatusCode: enrolmentStatusCode,
    });
  }
}

// What - Points Balance (Request)
// When - When application requests for points' balance, it would trigger this event
export function pointsRequest(status: string) {
    const newrelic = window?.newrelic;
  if (newrelic != undefined) {
    newrelic.addPageAction("pointsRequest", {
      status: status,
      promiseTime: new Date().toDateString(),
    });
  }
}

// What - Points Balance (Response)
// When - When application sends a response for points' balance, it would trigger this event
export function pointsResponse(status: string, points = "") {
    const newrelic = window?.newrelic;
  if (newrelic != undefined) {
    newrelic.addPageAction("pointsResponse", {
      status: status,
      promiseTime: new Date().toDateString(),
      points: points,
    });
  }
}

// What - Load offers' events
// When - When application loads offers, it would trigger this event
export function fetchOffers(
  status: any,
  daysRange: any,
  language: any,
  pendingOffersCount = 0,
  activeOffersCount = 0,
  redeemedOffersCount = 0,
  expiredOffersCount = 0
) {
    const newrelic = window?.newrelic;
  if (newrelic != undefined) {
    newrelic.addPageAction("getOffers", {
      status: status,
      promiseTime: new Date().toDateString(),
      daysRange: daysRange,
      language: language,
      pendingOffersCount: pendingOffersCount,
      activeOffersCount: activeOffersCount,
      redeemedOffersCount: redeemedOffersCount,
      expiredOffersCount: expiredOffersCount,
    });
  }
}
// What - Load member pending offers' events
// When - When application loads members' pending offers, it would trigger this event
export function loadOffers(status: any, language: any, offersCount = 0) {
    const newrelic = window?.newrelic;
  if (newrelic != undefined) {
    newrelic.addPageAction("loadOffers", {
      status: status,
      promiseTime: new Date().toDateString(),
      language: language,
      offersCount: offersCount,
    });
  }
}

// What - Display a prompt
// When - When application displays a prompt, it would trigger this event
export function promptDisplay(status: string, promptName: string) {
    const newrelic = window?.newrelic;
  if (newrelic != undefined) {
    newrelic.addPageAction("promptDisplay", {
      status: status,
      promiseTime: new Date().toDateString(),
      promptName: promptName,
    });
  }
}

// What - Dismiss prompt
// When - When application dismisses a prompt, it would trigger this event
export function promptDismiss(status: string, promptName: string) {
    const newrelic = window?.newrelic;
  if (newrelic != undefined) {
    newrelic.addPageAction("promptDismiss", {
      status: status,
      promiseTime: new Date().toDateString(),
      promptName: promptName,
    });
  }
}

// What - Remind Later Prompt
// When - When application sets a remind later prompt, it would trigger this event
export function promptRemindLater(status: string, promptName: string) {
    const newrelic = window?.newrelic;
  if (newrelic != undefined) {
    newrelic.addPageAction("promptRemindLater", {
      status: status,
      promiseTime: new Date().toDateString(),
      promptName: promptName,
    });
  }
}

export function addSceneCard(status: string, cardNumber: string) {
    const newrelic = window?.newrelic;
  if (newrelic) {
    if (cardNumber?.length) {
      const hashedCardNumber = hashCard(cardNumber.slice(-10));
      newrelic.addPageAction("addSceneCard", {
        status: status,
        promiseTime: new Date().toDateString(),
        "enduser.lpCard": hashedCardNumber,
      });
    }
  }
}
